import Translate from '../i18n/Translate'
//Intersection Observer
import { useInView } from 'react-intersection-observer'
//Hooks
import useScrollTop from '../hooks/useScrollTop'
import useWindowWidth from '../hooks/useWindowWidth'
//Components
import TopSearch from '../containers/Itinerary/TopSearch'
import FiltersMobile from '../containers/Itinerary/FiltersMobile'
import DestinationFilter from '../components/Itinerary/DestinationFilter'
import ItinerariesList from '../containers/Itinerary/ItinerariesList'
import OperatorsGallery from '../components/OperatorsGallery'
import useSetI18nProviderInformation from '../hooks/useSetI18nProviderInformation'

const Itineraries = () => {
    useScrollTop()
    useSetI18nProviderInformation('itineraries')

    const windowWidth = useWindowWidth()
    const [itineraryTopRef, inView] = useInView()

    return (
        <div className="incoming-itinerary">
            <div className="incoming-itinerary__top">
                <div className={`content animate slide-title ${inView ? 'in-view' : ''}`} ref={itineraryTopRef}>
                    <h1 className="title top-title">
                        <Translate langkey="itinerary.title" />
                    </h1>
                    <p className="copy top-subtitle">
                        <Translate langkey="itinerary.subtitle" />
                    </p>
                </div>
            </div>
            <TopSearch />
            <div className="incoming-itinerary__wrapper">
                <div className="aside">
                    {windowWidth < 992 ? (
                        <FiltersMobile />
                    ) : (
                        <div className="filters-desktop">
                            <DestinationFilter background="bg-light" />
                        </div>
                    )}
                </div>
                <div className="list-wrapper">
                    <ItinerariesList />
                </div>
            </div>
            <OperatorsGallery />
        </div>
    )
}

export default Itineraries
